import React from 'react';
import { layout, LoadingIconPrimary } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { ResourceIcon } from 'Components/ResourceIcon';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

const StyledDiv = styled.div`
	position: absolute;
	right: ${layout.smallSpace};
	top: ${layout.smallSpace};
	background: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(5px);
	padding: ${layout.smallSpace};
	border-radius: ${layout.space8};
	box-sizing: border-box;
	height: ${layout.space48};
`;

interface Props {
	resource: Resource;
}

const iconSize = 32;

export const DesktopIcon = ({ resource }: Props) => {
	const { value: resourceContext } = useLoadableResourceContext();
	const isLoading = resourceContext.isInProgress(resource.id);
	return (
		<StyledDiv>
			{isLoading ? (
				<LoadingIconPrimary size={iconSize} />
			) : (
				<ResourceIcon resource={resource} size={iconSize} />
			)}
		</StyledDiv>
	);
};
